export enum types {
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary"
}
